import { InformationCircleIcon } from '@heroicons/react/24/outline'

export default function FourCTooltip({ inline = false }) {
  const tooltipClasses = inline 
    ? 'inline-flex items-center' 
    : 'inline-block'

  return (
    <span className={`${tooltipClasses} group relative`}>
      <InformationCircleIcon className="w-4 h-4 text-gray-400 hover:text-cte-blue cursor-help ml-1" />
      <div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-4 py-3 bg-gray-900 text-white text-sm rounded-lg shadow-lg w-64 z-50 pointer-events-none">
        <div className="font-semibold mb-2">The 4C Pattern:</div>
        <ul className="space-y-1 text-xs">
          <li><strong>Context:</strong> Background information</li>
          <li><strong>Constraint:</strong> Boundaries and limits</li>
          <li><strong>Clarity:</strong> Clear objectives</li>
          <li><strong>Criteria:</strong> Success measures</li>
        </ul>
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
          <div className="border-4 border-transparent border-t-gray-900"></div>
        </div>
      </div>
    </span>
  )
}
